import { createSelector } from 'reselect';
import { getKaMetlhaFuneralClaim } from './index';
import { KMF_CLAIM_PAGE_INDICES } from '../../actions/kaMetlhaFuneralClaim/types';
import { FORM_STATUS } from '../../reducers/status';

export const getClaimentDetails = createSelector(
    getKaMetlhaFuneralClaim,
    (kaMetlhaFuneralClaim) => kaMetlhaFuneralClaim.claimentDetails
);
export const getClaimentDetailsForm = createSelector(getClaimentDetails, (claimentDetails) => claimentDetails.form);
const makeGetField = (fieldId) =>
    createSelector(getClaimentDetailsForm, (claimentDetailsForm) => claimentDetailsForm[fieldId]);

export const getFirstName = makeGetField('firstName');
export const getClaimentType = makeGetField('claimentType');
export const idSelected = makeGetField('idSelected')

const policyHolderDocuments = [
    { name: 'proofOfAddress', description: 'Proof of address', requiredFor: 'Claimant' },
    { name: 'deathCertificate', description: 'Certified Copy of Death certificate',  requiredFor: 'Deceased'  },
    { name: 'affidavit', description: 'Affidavit Confirming Relationship', requiredFor: 'Deceased' },
    { name: 'confirmationOfBankAccount', description: 'Confirmation of bank account', requiredFor: 'Claimant' },
    { name: 'claimantsIdInput', description: 'Claimant Id Proof', requiredFor: 'Claimant' },
    { name: 'affidavitSurname', description: 'Affidavit Confirming Surname is Difference', requiredFor: 'Deceased' },
    { name: 'marriageCertificate', description: 'Certified copy of marriage certificate; Commissioner of oath', requiredFor: 'Deceased'},
    { name: 'marriageAffidavit', description: 'Declaration/affidavit from a third party confirming the duration of relationship e.g., Tribal Chief, Minister of Religion, Parents of the deceased', requiredFor: 'Deceased'},
    { name: 'childBirthCertificate', description: 'Certified copy of child’s birth certificate', requiredFor: 'Deceased'},
    { name: 'policeReport', description: 'Police Report', requiredFor: 'Deceased'}
    
];
const beneficiaryDocs = [
    ...policyHolderDocuments,
    { name: 'beneficiaryId', description: 'Certified copy of Beneficiary ID' },
    
];
const nomineeDocs = [
    ...policyHolderDocuments,
];
const uploadDocumentsByClaimentType = {
    '01': policyHolderDocuments,
    '02': beneficiaryDocs,
    '03': nomineeDocs,
};
export const getDocumentsToBeUploaded = createSelector(
    getClaimentType,
    (claimentType) => uploadDocumentsByClaimentType[claimentType.value]
);

export const getClaimentDetailsValid = createSelector(
    getClaimentDetails,
    (claimentDetails) => claimentDetails.formStatus === FORM_STATUS.VALID
);

export const getClaimentDetailsValidations = createSelector(getClaimentDetailsForm, (claimentDetailForm) => {
    const {
        claimentType,
        firstName,
        lastName,
        idNumber,
        relationshipToPolicyHolder,
        streetAddress,
        city,
        district,
        residentialDuration,
        occupation,
        policyNumber,
        dateOfBirth,
        accountHolderId,
        accountHolderName,
        bank,
        bankBranch,
        accountNumber,
        accountType,
        title,
        idSelected,
        nationality,
        country,
        email,
        mobileNumber,
        residenceTimePeriod,
        previousPostalAddress,
        previousPostalCity,
        previousPostalCountry,
        postalSuburb,
        postalCity,
        postalCountry,
        employeeOccupation,
        otherEmployeeOccupation
    } = claimentDetailForm;
    const policyHolderDetailsFormFields = {
        title,
        firstName,
        lastName,
        policyNumber,
        dateOfBirth,
        idSelected,
        accountHolderId,
        nationality,
        country,
        city,
        email,
        mobileNumber,
        streetAddress,
        residenceTimePeriod,
        employeeOccupation,
        ...(employeeOccupation?.value==="Other" && {otherEmployeeOccupation}),
        ...(residenceTimePeriod?.value==="Less than two years" && {previousPostalAddress,previousPostalCity,previousPostalCountry}),
        bank,
        bankBranch,
        accountNumber,
        accountType,
        accountHolderName
    };
    const defaultFormFields = { claimentType };
    const beneficiaryDetailsFormFields = {
        title,
        firstName,
        lastName,
        idSelected,
        accountHolderId,
        relationshipToPolicyHolder,
        streetAddress,
        city,
        email,
        country,
        residenceTimePeriod,
        ...(residenceTimePeriod?.value==="Less than two years" && {previousPostalAddress,previousPostalCity,previousPostalCountry}),
        employeeOccupation,
        ...(employeeOccupation?.value==="Other" && {otherEmployeeOccupation}),
        accountHolderName,
        bank,
        bankBranch,
        accountNumber,
        accountType
    };
    const nomineeDetailsFormFields = beneficiaryDetailsFormFields;
    const claimentDetailsFormFields = {
        Beneficiary: beneficiaryDetailsFormFields,
        'Policy holder': policyHolderDetailsFormFields,
        Nominee: nomineeDetailsFormFields,
        default: defaultFormFields,
    };
    return claimentDetailsFormFields[claimentType.displayValue ?? 'default'];
});



       

const inputFieldLabels = {
    claimentType:'Claiment Type',
    relationshipToPolicyHolder:'Relationship to policy holder',
    policyNumber:'Policy number',
    dateOfBirth:'Date of birth',
    accountHolderName:'Account holder name',
    bank:'Bank name',
    bankBranch:'Branch name',
    accountNumber:'Account number',
    accountType:'Account type',
    accountHolderId:'ID number',
    nationality:'Nationality',
    email:'Email address',
    mobileNumber:'Contact number',
    streetAddress: 'Plot number/suburb/ward',
    city: 'City/Town/Village',
    country: 'Country',
    residenceTimePeriod: 'How long have you been living in this address?',
    previousPostalAddress: 'Previous plot number/suburb/ward',
    previousPostalCity: 'Previous City/Town/Village',
    previousPostalCountry: 'Previous Country',
    postalSuburb: 'P O Box/Private Bag/Suburb/Ward',
    postalCity: 'Postal City/Town/Village',
    postalCountry: 'Postal Country',
    employeeOccupation:'Employee occupation',
    otherEmployeeOccupation:'Other Employee occupation' 
    
};
export const getClaimentDetailsSummary = createSelector(
    getClaimentDetailsValidations,
    (formFieldsFiltered) => {
        const fullName = formFieldsFiltered['title']?.value+ ' ' +formFieldsFiltered['firstName']?.value + ' '+ (formFieldsFiltered['middleName']?.value ?? '') + ' ' + formFieldsFiltered['lastName']?.value
        const claimentDetailsSummary= Object.keys(formFieldsFiltered).flatMap((item) => {
            return {
                label: inputFieldLabels[item],
                value: formFieldsFiltered[item]?.displayValue ?? '-',
            };
        }).filter(({label})=>label);
        return [{label:'Full name',value:fullName}, ...claimentDetailsSummary, ]
    }
);